//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from '../../../components/helpers.js'
import { EventBus } from '../../../EventBus/EventBus.js'
import ReportMaterialsTable from './ReportMaterialsTable.vue'
import ReportMaterialsRequestMaterial from './ReportMaterialsRequestMaterial.vue'
import ReportMaterialsConsumptionEditor from './ReportMaterialsConsumptionEditor.vue'
import ReportRemarkImportantCheckbox from '../ReportRemarkImportantCheckbox.vue'
import { formatRecId, formatTrueFalse, getTagByKey } from './ReportMaterialsHelperFunctions.js'

export default {
  components: {
    ReportMaterialsTable: ReportMaterialsTable,
    ReportMaterialsRequestMaterial: ReportMaterialsRequestMaterial,
    ReportRemarkImportantCheckbox
  },
  props: {
    consumptions: {
      type: Array,
      default () {
        return []
      }
    },
    mountings: {
      type: Array,
      default () {
        return []
      }
    },
    demountings: {
      type: Array,
      default () {
        return []
      }
    },
    materialesAvailable: {
      type: Array,
      default () {
        return []
      }
    },
    standardSpecification: {
      type: Array,
      default () {
        return []
      }
    },
    projects: {
      type: Array,
      default () {
        return []
      }
    },
    reportId: {
      type: Number,
      default: 0
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    checking: {
      type: Boolean,
      default: false
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      selectedItemsLength: 0,
      updateSegmentHandler: null,

      columns: [
        {
          name: 'toolName',
          label: 'Название',
          align: 'left',
          field: 'toolName',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'toolKey',
          label: 'ID номенклатурной позиции в 1С',
          align: 'left',
          field: 'toolKey',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'amount',
          label: 'Кол-во',
          align: 'left',
          field: 'amount',
          sortable: true
        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: 'unit',
          sortable: true
        },
        {
          name: 'loops',
          label: 'Кол-во петель',
          align: 'left',
          field: 'loops',
          sortable: true
        },
        {
          name: 'sn',
          label: 'Серийный номер',
          align: 'left',
          field: 'sn',
          sortable: true
        },
        {
          name: 'projectName',
          label: 'Проект',
          align: 'left',
          field: 'projectName',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'mountingId',
          label: 'Монтаж',
          align: 'left',
          field: 'mountingId',
          sortable: true,
          format: this.formatMountingId,
          defaultWidth: 200
        },
        {
          name: 'demountingId',
          label: 'Замена',
          align: 'left',
          field: 'demountingId',
          sortable: true,
          format: this.formatDemountingId,
          defaultWidth: 200
        },
        {
          name: 'tag',
          label: 'Тег',
          align: 'left',
          field: 'tag',
          format: tag => getTagByKey(tag, this.tags),
          sortable: true,
          defaultWidth: 100
        },
        {
          name: 'comment',
          label: 'Комментарий исполнителя',
          align: 'left',
          field: 'comment',
          sortable: true
        },
        {
          name: 'noted',
          label: 'Результат проверки',
          align: 'left',
          field: 'noted',
          sortable: true
        },
        {
          name: 'note',
          label: 'Замечание аналитика',
          align: 'left',
          field: 'note',
          sortable: true
        },
        {
          name: 'df',
          label: 'Учёт в ДФ',
          align: 'left',
          field: 'df',
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 100
        },
        {
          name: 'changed',
          label: 'Изменено',
          align: 'left',
          field: 'changed',
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 100
        },
        {
          name: 'time',
          label: 'Дата/время',
          align: 'left',
          field: 'time',
          sortable: true,
          format: formatTime,
          defaultWidth: 150
        },
        {
          name: 'user',
          label: 'Сотрудник',
          align: 'left',
          field: 'user',
          sortable: true,
          defaultWidth: 200
        }
      ]
    }
  },
  computed: {
    displayRequestMaterialButton: function () {
      return this.report.stateId === 'PR4' || this.report.stateId === 'PR7' || this.report.stateId === 'PR8' || this.report.stateId === 'PR9' || this.report.stateId === 'PR10'
    }
  },
  created: function () {
    this.updateSegmentHandler = (data) => {
      if (this.report.key !== data.reportKey) {
        return
      }
      const selectedSegment = data.segment

      if (data.operation.type === 'delete') {
        // обрабатывается в монтаже
      } else {
        if (selectedSegment.mountingId) {
          const mounting = this.mountings.find(mounting => mounting.recId === selectedSegment.mountingId)
          if (mounting && mounting.sourceTable === 'consumption') {
            const consumption = this.consumptions.find(consumption => consumption.mountingId === mounting.recId)
            if (consumption) {
              this.onEditConsumption(consumption, selectedSegment)
            }
          } else {
            // обрабатывается в монтаже и списании
          }
        }
      }
    }

    EventBus.$on('mounting-segment', this.updateSegmentHandler)
  },
  beforeDestroy: function () {
    EventBus.$off('mounting-segment', this.updateSegmentHandler)
  },
  methods: {
    onSelectedItems: function (selectedItemsLength) {
      this.selectedItemsLength = selectedItemsLength
    },
    onAddConsumption: function (operation, demountingId, selectedSegment) {
      if (operation !== 'mounting' && operation !== 'replacement') {
        operation = null
      }
      if (operation !== 'replacement') {
        demountingId = null
      }

      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: ReportMaterialsConsumptionEditor,
        contentProps: {
          record: null,
          isEdit: false,
          operation: operation,
          // ===
          consumptions: this.consumptions,
          mountings: this.mountings,
          demountings: this.demountings,
          projects: this.projects,
          tags: this.tags,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess,
          standardSpecification: this.standardSpecification
        },
        componentHandlers: {
          save: (consumption) => {
            dialog.hide()
            this.onSaveAddConsumption(consumption, operation, demountingId, selectedSegment)
          },
          close: () => {
            dialog.hide()
            this.onCloseAddConsumption(operation, demountingId)
          }
        }
      })
    },
    onAddRemark: function () {
      if (this.report.consumptionRemarks.length === 0) {
        this.report.consumptionRemarks.push({
          active: true,
          code: 'consumptionRemarks',
          comment: null,
          important: false
        })
      } else {
        this.report.consumptionRemarks[0].active = true
      }
    },
    onDeleteRemark: function () {
      if (this.report.consumptionRemarks.length !== 0) {
        this.report.consumptionRemarks[0].active = false
      }
    },
    onConsumptionsRemarkChanged: function () {
      this.$emit('consumptions-remarks')
    },
    onApproveSelectedConsumptions: function () {
      this.$refs.reportMaterialsTable.$refs.reportMaterialsTableDispatcher.approveSelectedItems()
    },
    onDeleteConsumption: function (row) {
      const index = this.consumptions.indexOf(row)

      if (row.mountingId) {
        this.$d_ask({
          callback: () => {
            this.consumptions.splice(index, 1) // TODO delete consumption
            const indexMounting = this.mountings.findIndex(mounting => mounting.recId === row.mountingId)
            this.mountings.splice(indexMounting, 1) // TODO delete mounting
          },
          header: 'У записи расхода есть связь с монтажом. Запись монтажа будет удалена.'
        })
      } else {
        this.consumptions.splice(index, 1) // TODO delete consumption
      }
    },
    onEditConsumption: function (record) {
      const index = this.consumptions.indexOf(record)
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: ReportMaterialsConsumptionEditor,
        contentProps: {
          record: record,
          isEdit: true,
          operation: null,
          // ===
          consumptions: this.consumptions,
          mountings: this.mountings,
          demountings: this.demountings,
          projects: this.projects,
          tags: this.tags,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess,
          standardSpecification: this.standardSpecification
        },
        componentHandlers: {
          save: (consumption) => {
            dialog.hide()
            this.onSaveEditConsumption(consumption, index)
          },
          close: () => dialog.hide()
        }
      })
    },
    onSaveEditConsumption: function (consumption, index) {
      const originalInitial = this.consumptions[index] ? this.consumptions[index]._initial : undefined
      consumption = JSON.parse(JSON.stringify(consumption)) // TODO new consumption

      if (originalInitial !== undefined) {
        Object.defineProperty(consumption, '_initial', {
          value: originalInitial,
          writable: false,
          enumerable: false,
          configurable: true
        })
      }
      this.consumptions.splice(index, 1, consumption) // TODO update consumption

      if (consumption.mountingId) {
        const mounting = this.mountings.find(mounting => mounting.recId === consumption.mountingId)
        mounting.toolKey = consumption.toolKey
        mounting.toolName = consumption.toolName
        mounting.amount = consumption.amount
        mounting.unit = consumption.unit
        mounting.tag = consumption.tag
        mounting.sn = consumption.sn
      }
    },
    onSaveAddConsumption: function (consumption, operation, demountingId, selectedSegment) {
      consumption = JSON.parse(JSON.stringify(consumption)) // TODO new consumption

      if (operation === 'mounting' || operation === 'replacement') {
        const mounting = {} // TODO new mounting
        mounting.toolKey = consumption.toolKey
        mounting.toolName = consumption.toolName
        mounting.amount = consumption.amount
        mounting.unit = consumption.unit
        mounting.sn = consumption.sn
        mounting.tag = consumption.tag
        mounting.sourceTable = 'consumption'
        mounting.recId = new Date().getTime()
        this.mountings.push(mounting) // TODO add mounting

        consumption.mountingId = mounting.recId

        if (selectedSegment) {
          selectedSegment.mountingId = mounting.recId
          consumption.isSegment = true
          mounting.isSegment = true
        }

        if (operation === 'replacement') {
          consumption.demountingId = demountingId
        }
      }

      consumption.recId = new Date().getTime()
      this.consumptions.push(consumption) // TODO add consumption
    },
    onCloseAddConsumption: function (operation, demountingId) {
      if (operation === 'replacement') {
        this.$parent.$parent.$parent.$parent.$refs.demountings.onDeleteDemounting(demountingId)
      }
    },
    onRequestMaterial: function (row) {
      this.$refs.requestMaterial.onRequestMaterial(row)
    },
    onChangeMaterialesAvailable: function (materialesAvailable) {
      this.$emit('change-materiales-available', materialesAvailable)
    },
    formatMountingId: function (value) {
      return formatRecId(value, this.mountings)
    },
    formatDemountingId: function (value) {
      return formatRecId(value, this.demountings)
    },
    onChangeProjects: function () {
      this.$refs.reportMaterialsTable.$refs.reportMaterialsTableDispatcher.onChangeProjects()
    }
  }
}

